import { render, staticRenderFns } from "./Imprint.html?vue&type=template&id=48071a02&scoped=true&"
import script from "./Imprint.js?vue&type=script&lang=js&"
export * from "./Imprint.js?vue&type=script&lang=js&"
import style0 from "./Imprint.scss?vue&type=style&index=0&id=48071a02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48071a02",
  null
  
)

export default component.exports